export const FULFILLMENT_UI_LABELS = {
  BROWSE_ALL: 'Browse All',
  IN_STORE: 'In Store',
  AVAILABLE_IN_STORE: 'Available In Store',
  DELIVERY: 'Delivery',
  TODAY: 'Today',
  TOMORROW: 'Tomorrow',
  FREE_DELIVERY: 'Free Delivery'
};

export const BROWSE_ALL_REFINEMENT = {
  value: 'browseAll',
  label: FULFILLMENT_UI_LABELS.BROWSE_ALL,
  refinementKey: 'mock_browseAll'
};

/**
 * Dimension Labels - How dimensions are named in searchModel (UPPERCASE)
 * These match the `dimension.label` values from the backend.
 * Used directly as keys in fulfillmentDimensions object.
 */
export const FULFILLMENT_DIMENSIONS_LABELS = {
  GET_IT_FAST: 'GET IT FAST',
  DELIVERY: 'DELIVERY',
  FREE_DELIVERY: 'FREE DELIVERY'
};

export const DELIVERY_REFINEMENTS = {
  ANYTIME: 'Anytime',
  TODAY: 'Today',
  BY_TOMORROW: 'By Tomorrow'
};

export const DELIVERY_REFINEMENTS_LABELS = Object.values(DELIVERY_REFINEMENTS);

export const IN_STORE_REFINEMENTS = {
  PICKUP_TODAY: 'Pick Up Today'
};

/**
 * Refinement Labels - The refinement.label values from searchModel
 * for PLP speed dimension refinements.
 */
export const REFINEMENT_LABELS = {
  PICKUP_TODAY: 'Pick Up Today',
  ANYTIME: 'Anytime',
  TODAY: 'Today',
  BY_TOMORROW: 'By Tomorrow',
  SAME_DAY_DELIVERY: 'Same-Day Delivery',
  NEXT_DAY_DELIVERY: 'Next-Day Delivery',
  FREE_1_2_DAY_DELIVERY: 'Free 1-2 Day Delivery'
};

export const GET_IT_FAST_DIMENSION_LABEL = 'Get It Fast';

export const PLP_SPEED_DIMENSION_LABEL = 'In Store or Delivery';
export const PLP_SPEED_FULFILLMENT_HEADER = 'Pickup & Delivery';

export const IN_STORE_CHIP_DIMENSION_LABEL = 'Available';

export const VALID_IN_STORE_DIMENSION_LABELS = [
  FULFILLMENT_UI_LABELS.IN_STORE,
  IN_STORE_CHIP_DIMENSION_LABEL,
  'Get It Fast'
];

export const FULFILLMENT_DIMENSION_LABELS_TO_CHECK = [
  ...(Object.values(FULFILLMENT_UI_LABELS)),
  IN_STORE_CHIP_DIMENSION_LABEL,
  PLP_SPEED_DIMENSION_LABEL
];

export const RATINGS_REFINEMENT_KEY = 'bwo5q';
export const HIGHLY_RATED_REFINEMENT_KEY = 'bwo5o';
export const PICK_UP_TODAY_REFINEMENT_KEY = '1z175a5';

export const ON_DISPLAY_ITEM = {
  label: 'Get It Fast',
  refinements: [{
    label: 'On Display',
    refinementLabel: 'On Display',
    refinementKey: 'onDisplay'
  }]
};

export const MAX_REFINEMENTS = 5;
export const BEST_RATED = 'Best-Rated';
export const HIGH_RATED = 'Highly-Rated';

export const REGEX_PATTERNS = {
  parentheses: /\(([^)]+)\)/,
  plainUnit: /\d+\s+(\w+\.?\w*)/,
  general: /^(?!\d+$)(?:\b\d+(\.\d+)?\s*)(?:\(([^)]+)\)|(\w+))/
};

export const FIT_COMPATIBILITY_DIMENSIONS = [
  'DEPTH (EXCLUDING HANDLES) (IN.)',
  'HEIGHT TO TOP OF DOOR HINGE (IN.)',
  'HEIGHT TO TOP OF REFRIGERATOR (IN.)',
  'INSTALLATION DEPTH',
  'REFRIGERATOR FIT WIDTH',
  'TOTAL CAPACITY (CU. FT.)',
  'CAPACITY (CU. FT.) - REFRIGERATORS',
  'REFRIGERATOR CAPACITY (CU. FT.)',
  'DEPTH (INCLUDING HANDLES) (IN.)',
  'RANGE SIZE (WIDTH)',
  'OVERALL PRODUCT HEIGHT (IN.)',
  'REFRIGERATOR WIDTH (IN.)',
  'DRYER FIT WIDTH',
  'WASHER FIT WIDTH',
  'PRODUCT DEPTH (IN.)',
  'PRODUCT WIDTH (IN.)',
  'PRODUCT HEIGHT (IN.)',
  'HEIGHT - MAXIMUM (IN)',
  'DEPTH - DOOR SHUT (WITH HANDLE) (IN.)',
  'DEPTH - DOOR SHUT (WITHOUT HANDLE) (IN.)',
  'MICROWAVE PRODUCT WIDTH (IN.)',
  'MICROWAVE PRODUCT DEPTH (IN.)',
  'MICROWAVE PRODUCT HEIGHT (IN.)'
];

export const searchSortTypes = [
  {
    name: 'Best Match',
    sortby: 'bestmatch',
    sortorder: 'asc'
  },
  {
    name: 'Top Sellers',
    sortby: 'topsellers',
    sortorder: 'desc'
  },
  {
    name: 'Price Low to High',
    sortby: 'price',
    sortorder: 'asc'
  },
  {
    name: 'Price High to Low',
    sortby: 'price',
    sortorder: 'desc'
  },
  {
    name: 'Top Rated Products',
    sortby: 'toprated',
    sortorder: 'asc'
  }
];

export const browseSortTypes = [
  {
    name: 'Top Sellers',
    sortby: 'topsellers',
    sortorder: 'desc'
  },
  {
    name: 'Most Popular',
    sortby: 'mostpopular',
    sortorder: 'asc'
  },
  {
    name: 'Price Low to High',
    sortby: 'price',
    sortorder: 'asc'
  },
  {
    name: 'Price High to Low',
    sortby: 'price',
    sortorder: 'desc'
  },
  {
    name: 'Top Rated Products',
    sortby: 'toprated',
    sortorder: 'asc'
  }
];

export const DEFAULT_LAYOUT_STYLE = 'Grid';
export const LIST_LAYOUT_STYLE = 'List';

export const MAX_PODS_TO_HYDRATE = { DESKTOP: 12, MOBILE: 6 };
export const HYDRATION_STANDARD_SCROLL_BUFFER = 1500;

// These deprecated constants are used by DeliveryOptionsContext.
// Remove when the context is deleted/refactored.
// Deprecated Aliases
export const FULFILLMENT_LABELS = FULFILLMENT_UI_LABELS;

// Deprecated - use uppercase property names
FULFILLMENT_DIMENSIONS_LABELS.instore = FULFILLMENT_DIMENSIONS_LABELS.GET_IT_FAST;
FULFILLMENT_DIMENSIONS_LABELS.delivery = FULFILLMENT_DIMENSIONS_LABELS.DELIVERY;
FULFILLMENT_DIMENSIONS_LABELS.freeDelivery = FULFILLMENT_DIMENSIONS_LABELS.FREE_DELIVERY;

export const KEY_PRODUCT_FEATURE_POD_CATEGORIES = [
  '5yc1vZc2ec',
  '5yc1vZc91o',
  '5yc1vZcerm',
  '5yc1vZc22a',
  '5yc1vZc28p',
  '5yc1vZc8lk',
  '5yc1vZ2fkoml9',
  '5yc1vZ1z18gv1',
  '5yc1vZ1z18gvv',
  '5yc1vZ1z18gva',
  '5yc1vZ1z18gw7',
  '5yc1vZ1z18gw1',
  '5yc1vZ1z18gw6',
  '5yc1vZ1z18gwg',
  '5yc1vZ1z18guy',
  '5yc1vZ1z18gwj',
  '5yc1vZ1z18gwd',
  '5yc1vZ1z18gw9',
  '5yc1vZ1z18gvg',
  '5yc1vZc5ax',
  '5yc1vZcarh',
  '5yc1vZcari',
  '5yc1vZc5ak',
  '5yc1vZc5c0',
  '5yc1vZcjob',
  '5yc1vZbrdj',
  '5yc1vZc2dc',
  '5yc1vZc2h7',
  '5yc1vZc2d7',
  '5yc1vZ2fkokir',
  '5yc1vZc3wt',
  '5yc1vZc29s',
  '5yc1vZc2f6',
  '5yc1vZc2br',
  '5yc1vZcc0i',
  '5yc1vZc26g',
  '5yc1vZ2fkool7',
  '5yc1vZc232',
  '5yc1vZc23t',
  '5yc1vZcc0k',
  '5yc1vZcc5t',
  '5yc1vZ2fkool0',
  '5yc1vZ2fkook4',
  '5yc1vZbmh8',
  '5yc1vZbmgk',
  '5yc1vZbmgj',
  '5yc1vZbmgp',
  '5yc1vZc6xq',
  '5yc1vZc4dq',
  '5yc1vZbtxa',
  '5yc1vZbtxc',
  '5yc1vZ2fkom5w',
  '5yc1vZ2fkom5o',
  '5yc1vZc5lx',
  '5yc1vZc3ph',
  '5yc1vZbtz2',
  '5yc1vZbu93',
  '5yc1vZbu8z',
  '5yc1vZbu95'
];